import { render, staticRenderFns } from "./AptListManage.vue?vue&type=template&id=267ab0c3&scoped=true"
import script from "./AptListManage.vue?vue&type=script&lang=js"
export * from "./AptListManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267ab0c3",
  null
  
)

export default component.exports